(() => {
  'use strict';
  const origins = new WeakMap();
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  let toastTimer;
  function open(dialog, origin = document.activeElement) {
    if (!dialog || !dialog.showModal) return;
    if (dialog.open) return;
    origins.set(dialog, origin);
    dialog.showModal();
    document.body.classList.add('modal-open');
    $('[data-dialog-focus]', dialog)?.focus({preventScroll: true});
    document.dispatchEvent(new Event('calma-dialog-change'));
  }
  function bindDialog(dialog) {
    if (dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => {
      if (!$('dialog[open]')) document.body.classList.remove('modal-open');
      const origin = origins.get(dialog);
      if (origin?.isConnected) origin.focus({preventScroll: true});
      document.dispatchEvent(new Event('calma-dialog-change'));
    });
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  }
  $$('dialog').forEach(bindDialog);
  function toast(message) {
    const node = $('#toast');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => node.classList.remove('is-visible'), 4000);
  }
  const info = $('#info-dialog');
  let currentDocument = null;
  function restoreDocument() {
    if (currentDocument) {
      currentDocument.append($('#info-dialog-content').firstElementChild);
      currentDocument = null;
    }
  }
  function openLegal(slug, origin, review = false) {
    const source = document.getElementById(slug);
    if (!source?.matches('[data-legal-document]') || !info) return false;
    restoreDocument();
    const content = $('[data-legal-body]', source);
    if (!content) return false;
    currentDocument = source;
    $('#info-dialog-title').textContent = $('summary', source).textContent;
    $('#info-dialog-content').replaceChildren(content);
    if (review) {
      const subject = $('#ContactSubject', content);
      if (subject) subject.value = 'Produktbewertung Fergoli One';
      $('#ReviewFields', content)?.removeAttribute('hidden');
    }
    open(info, origin);
    $('#info-dialog-scroll').scrollTop = 0;
    return true;
  }
  if (info && typeof HTMLDialogElement !== 'undefined') {
    document.documentElement.classList.add('legal-dialog-ready');
    info.addEventListener('close', restoreDocument);
  }
  function closeMenu() {
    const button = $('.menu-button');
    button?.setAttribute('aria-expanded', 'false');
    button?.setAttribute('aria-label', 'Menü öffnen');
    const menu = $('#mobile-nav');
    if (menu) menu.hidden = true;
  }
  document.addEventListener('click', e => {
    const close = e.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    const menuButton = e.target.closest('.menu-button');
    if (menuButton) {
      const expanded = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(expanded));
      menuButton.setAttribute('aria-label', expanded ? 'Menü schliessen' : 'Menü öffnen');
      $('#mobile-nav').hidden = !expanded;
    } else if (e.target.closest('#mobile-nav a') || !e.target.closest('.header')) closeMenu();
    const link = e.target.closest('[data-legal]');
    if (link && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0 && typeof HTMLDialogElement !== 'undefined') {
      if (openLegal(link.dataset.legal, link, link.hasAttribute('data-review-request'))) e.preventDefault();
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
  function openHash() {
    const hash = decodeURIComponent(location.hash.slice(1));
    const source = document.getElementById(hash)?.closest('[data-legal-document]');
    if (source && typeof HTMLDialogElement !== 'undefined') openLegal(source.id, null);
  }
  window.addEventListener('hashchange', openHash);
  if ($('[data-contact-status]')) openLegal('kontakt', null);
  else openHash();
  window.FergoliUI = {openDialog: open, toast, bindDialog};
})();
